import React, { useState } from "react";
import { generateInvoicePDF } from "./generateInvoicePDF";
import { formatInvoiceNumber } from "./pdfUtils";
import logoRaw from "../../../../assets/images/logo.png";

const InvoicePDFButton = ({ order, className, label }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (loading || !order) return;
    setLoading(true);

    try {
      const doc = await generateInvoicePDF(order, logoRaw);
      doc.save(`${formatInvoiceNumber(order)}.pdf`);
    } catch (err) {
      console.error("[InvoicePDFButton] Erro ao gerar PDF:", err);
      alert("Não foi possível gerar o PDF. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  // Variante de item de menu (ex: menu "⋯" da tabela de Vendas)
  if (className) {
    return (
      <button
        type="button"
        role="menuitem"
        className={className}
        onClick={handleDownload}
        disabled={loading}
        title="Baixar fatura PDF"
      >
        <i
          className={loading ? "fa fa-spinner fa-spin" : "fa fa-file-pdf-o"}
          style={{ width: 15, textAlign: "center" }}
        />
        {loading ? "Gerando PDF..." : label}
      </button>
    );
  }

  return (
    <button
      onClick={handleDownload}
      disabled={loading}
      title="Baixar fatura PDF"
      style={{
        background: "none",
        border: "none",
        cursor: loading ? "wait" : "pointer",
        padding: "0 4px",
        color: loading ? "#aaa" : "#555",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      {loading ? (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: 14 }} />
      ) : (
        <i className="fa fa-file-pdf-o" style={{ fontSize: 14 }} />
      )}
    </button>
  );
};

export default InvoicePDFButton;
